<template>
  <!-- BREADCRUMB (mode: detail) -->
  <div v-if="mode === 'detail'" class="d-flex align-items-center gap-2 mb-3" style="font-size:0.875rem">
    <a class="text-primary fw-semibold" style="cursor:pointer" @click="$router.push('/asset/asset-it')">
      Asset Laptop / PC
    </a>
    <i class="bi bi-chevron-right text-muted" style="font-size:12px"></i>
    <span class="text-muted">Details</span>
  </div>
  
  <!-- BACK LINK (mode: add/edit) -->
  <div v-if="mode === 'add' || mode === 'edit'" class="mb-3">
    <a class="d-flex align-items-center gap-2 text-primary fw-semibold" style="cursor:pointer;width:fit-content"
      @click="goBack">
      <i class="bi bi-arrow-left"></i> Back
    </a>
  </div>
  
  <div class="card-modern p-4">
  
    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="fw-bold text-dark mb-0">{{ pageTitle }}</h3>
      <button v-if="mode === 'detail'" class="btn btn-secondary" @click="goBack">
        Back
      </button>
    </div>
  
    <!-- ================= DETAIL ================= -->
    <template v-if="mode === 'detail'">
      <div class="row g-3">
  
        <!-- KOLOM KIRI: Identitas + User Detail -->
        <div class="col-lg-6 d-flex flex-column gap-3">
  
          <!-- Identitas Asset -->
          <div class="border rounded p-3">
            <p class="fw-semibold text-muted small text-uppercase mb-3">Identitas Asset</p>
            <div class="row g-3">
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Device Type</small>
                <div class="fw-semibold">{{ detail.device_type_name || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Serial Number</small>
                <div class="fw-semibold">{{ detail.serial_number || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Kondisi Barang</small>
                <div class="fw-semibold">{{ detail.asset_condition_name || '-' }}</div>
              </div>
  
              <div class="col-12">
                <small class="text-muted d-block mb-1">Asset Number</small>
                <div v-if="detail.asset_numbers && detail.asset_numbers.length" class="d-flex flex-wrap gap-2">
                  <span v-for="item in detail.asset_numbers" :key="item.asset_number_id"
                    class="badge bg-light text-dark border fw-semibold">
                    {{ item.asset_number }}
                  </span>
                </div>
                <div v-else class="fw-semibold">-</div>
              </div>
  
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Purchase Date</small>
                <div class="fw-semibold">{{ formatDate(detail.asset_purchase_date) }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Received Date</small>
                <div class="fw-semibold">{{ formatDate(detail.asset_receive_date || detail.asset_received_date) }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Handover Date</small>
                <div class="fw-semibold">{{ formatDate(detail.asset_handover_date) }}</div>
              </div>
            </div>
          </div>
  
          <!-- User Detail -->
          <div class="border rounded p-3">
            <p class="fw-semibold text-muted small text-uppercase mb-3">User Detail</p>
            <div class="row g-3">
              <div class="col-6">
                <small class="text-muted d-block mb-1">Employee</small>
                <div class="fw-semibold">{{ detail.mst_employee_name || detail.asset_user_name || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">NIK</small>
                <div class="fw-semibold">{{ detail.asset_user_nik || detail.mst_employee_nik || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">Corporate</small>
                <div class="fw-semibold">{{ detail.mst_corporate_name || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">Site</small>
                <div class="fw-semibold">{{ detail.mst_site_name || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">Department</small>
                <div class="fw-semibold">{{ detail.mst_division_name || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">Position</small>
                <div class="fw-semibold">{{ detail.mst_position_name || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- KOLOM KANAN: Hardware + Lisensi -->
        <div class="col-lg-6 d-flex flex-column gap-3">
  
          <!-- Spesifikasi Hardware -->
          <div class="border rounded p-3">
            <p class="fw-semibold text-muted small text-uppercase mb-3">Spesifikasi Hardware</p>
            <div class="row g-3">
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Merk</small>
                <div class="fw-semibold">{{ detail.asset_merk || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Type</small>
                <div class="fw-semibold">{{ detail.asset_type || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Processor</small>
                <div class="fw-semibold">{{ detail.asset_processor || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">RAM</small>
                <div class="fw-semibold">{{ detail.asset_ram || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">HDD</small>
                <div class="fw-semibold">{{ detail.asset_hdd || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">SSD</small>
                <div class="fw-semibold">{{ detail.asset_ssd || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Operating System</small>
                <div class="fw-semibold">{{ detail.asset_operating_system || '-' }}</div>
              </div>
              <div class="col-6 col-md-4">
                <small class="text-muted d-block mb-1">Microsoft Office</small>
                <div class="fw-semibold">{{ detail.asset_office || '-' }}</div>
              </div>
            </div>
          </div>
  
          <!-- Lisensi -->
          <div class="border rounded p-3">
            <p class="fw-semibold text-muted small text-uppercase mb-3">Lisensi</p>
            <div class="row g-3">
              <div class="col-6">
                <small class="text-muted d-block mb-1">COA OS</small>
                <div class="fw-semibold">{{ detail.asset_coa_os || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">COA Office</small>
                <div class="fw-semibold">{{ detail.asset_coa_office || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">Product Key OS</small>
                <div class="fw-semibold text-break">{{ detail.asset_product_key_os || '-' }}</div>
              </div>
              <div class="col-6">
                <small class="text-muted d-block mb-1">Product Key Office</small>
                <div class="fw-semibold text-break">{{ detail.asset_product_key_office || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- DOKUMEN (full width) -->
        <div class="col-12">
          <div class="border rounded p-3">
            <p class="fw-semibold text-muted small text-uppercase mb-3">Dokumen</p>
  
            <div class="row g-4">
              <!-- PDF pendukung -->
              <div class="col-lg-6">
                <small class="text-muted d-block mb-2">Dokumen Pendukung</small>
  
                <!-- file lama (kolom file_path) -->
                <div v-for="(key, idx) in detailFileList" :key="'d-old-' + idx"
                  class="d-flex align-items-center justify-content-between py-2 px-3 border rounded-3 mb-2">
                  <div class="d-flex align-items-center gap-2 text-truncate">
                    <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                    <span class="text-truncate small">{{ getFileName(key) }}</span>
                  </div>
                  <button class="btn btn-outline-primary btn-sm flex-shrink-0" title="Lihat" @click="downloadFile(key)">
                    <i class="bi bi-eye"></i>
                  </button>
                </div>
  
                <!-- dokumen bertipe -->
                <template v-for="doc in (detail.documents || [])" :key="'d-doc-' + doc.asset_document_id">
                  <div v-if="!(doc.is_image == 1 || doc.document_type == 4)"
                    class="d-flex align-items-center justify-content-between py-2 px-3 border rounded-3 mb-2">
                    <div class="d-flex align-items-center gap-2 text-truncate">
                      <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                      <span class="text-truncate small">{{ doc.file_name || getFileName(doc.file_path) }}</span>
                    </div>
                    <button class="btn btn-outline-primary btn-sm flex-shrink-0" title="Lihat"
                      @click="downloadFile(doc.file_path)">
                      <i class="bi bi-eye"></i>
                    </button>
                  </div>
                </template>
  
                <div
                  v-if="!detailFileList.length && !(detail.documents || []).some(d => !(d.is_image == 1 || d.document_type == 4))"
                  class="text-muted small py-2">
                  Belum ada dokumen.
                </div>
              </div>
  
              <!-- Gambar lisensi + bukti retired -->
              <div class="col-lg-6">
                <small class="text-muted d-block mb-2">Gambar Lisensi</small>
                <template v-for="doc in (detail.documents || [])" :key="'d-img-' + doc.asset_document_id">
                  <div v-if="doc.is_image == 1 || doc.document_type == 4"
                    class="d-flex align-items-center justify-content-between py-2 px-3 border rounded-3 mb-2">
                    <div class="d-flex align-items-center gap-2 text-truncate">
                      <i class="bi bi-image text-secondary fs-5"></i>
                      <span class="text-truncate small">{{ doc.file_name || getFileName(doc.file_path) }}</span>
                    </div>
                    <button class="btn btn-outline-primary btn-sm flex-shrink-0" title="Lihat"
                      @click="downloadFile(doc.file_path)">
                      <i class="bi bi-eye"></i>
                    </button>
                  </div>
                </template>
                <div v-if="!(detail.documents || []).some(d => d.is_image == 1 || d.document_type == 4)"
                  class="text-muted small py-2">
                  Belum ada gambar.
                </div>
  
                <!-- Bukti penjualan / pemusnahan (khusus Retired) -->
                <template v-if="detail.status == 2">
                  <small class="text-muted d-block mt-4 mb-2">Bukti Penjualan / Pemusnahan</small>
                  <div v-if="detail.retired_file"
                    class="d-flex align-items-center justify-content-between py-2 px-3 border rounded-3">
                    <div class="d-flex align-items-center gap-2 text-truncate">
                      <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                      <span class="text-truncate small">{{ getFileName(detail.retired_file) }}</span>
                    </div>
                    <button class="btn btn-outline-primary btn-sm flex-shrink-0" title="Lihat"
                      @click="downloadFile(detail.retired_file)">
                      <i class="bi bi-eye"></i>
                    </button>
                  </div>
                  <div v-else class="text-muted small py-2">Belum ada dokumen.</div>
                </template>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </template>
  
    <!-- ================= ADD / EDIT ================= -->
    <template v-else>
      <div class="d-flex flex-column gap-3">
  
        <!-- 1. Identitas Asset -->
        <div class="border rounded p-3">
          <p class="fw-semibold text-muted small text-uppercase mb-3">Identitas Asset</p>
          <div class="row g-3">
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Asset Type <span class="text-danger">*</span></label>
              <Multiselect v-model="form.device_type_id" :options="deviceTypeList" valueProp="device_type_id"
                label="device_type_name" track-by="device_type_name" placeholder="-- Pilih Device Type --"
                :searchable="true" :can-clear="true" :disabled="mode === 'edit'" />
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Serial Number</label>
              <input type="text" class="form-control" v-model="form.serial_number" :disabled="mode === 'edit'"
                :class="{ 'bg-light': mode === 'edit' }">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Status</label>
              <select class="form-select" v-model="form.status">
                <option :value="1">Active</option>
                <option :value="0">Inactive</option>
                <option :value="2">Retired</option>
              </select>
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Kondisi Barang</label>
              <select class="form-select" v-model="form.asset_condition">
                <option :value="null">-- Pilih Kondisi --</option>
                <option v-for="c in conditionList" :key="c.value" :value="c.value">
                  {{ c.label }}
                </option>
              </select>
            </div>
  
            <div class="col-12">
              <label class="form-label fw-semibold">Asset Number</label>
              <div class="d-flex flex-wrap gap-2 align-items-center">
                <div v-for="(item, index) in form.asset_numbers" :key="index" class="input-group" style="width: 220px">
                  <input type="text" class="form-control" v-model="item.value"
                    :disabled="mode === 'edit' && !!item.asset_number_id"
                    :class="{ 'bg-light': mode === 'edit' && !!item.asset_number_id }">
                  <button v-if="form.asset_numbers.length > 1 && !(mode === 'edit' && item.asset_number_id)" type="button"
                    class="btn btn-outline-danger" title="Hapus" @click="removeAssetNumber(index)">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
                <button type="button" class="btn btn-outline-success" title="Tambah nomor aset" @click="addAssetNumber">
                  <i class="bi bi-plus-lg"></i>
                </button>
              </div>
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Purchase Date</label>
              <input type="date" class="form-control" v-model="form.asset_purchase_date">
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Received Date</label>
              <input type="date" class="form-control" v-model="form.asset_receive_date">
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Handover Date</label>
              <input type="date" class="form-control" v-model="form.asset_handover_date">
            </div>
  
          </div>
        </div>
  
        <!-- 2. User Detail -->
        <div class="border rounded p-3">
          <p class="fw-semibold text-muted small text-uppercase mb-3">User Detail</p>
          <div class="row g-3">
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Nama User <span class="text-danger">*</span></label>
              <Multiselect v-model="userSelect" class="uppercase-select" :options="employeeOptions" valueProp="value"
                label="label" track-by="label" :object="true" :searchable="true" :taggable="true" :create-option="true" :can-clear="true"
                @change="onUserSelectChange" />
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">NIK</label>
              <input type="text" class="form-control" v-model="form.asset_user_nik" />
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Corporate</label>
              <Multiselect v-model="form.mst_corporate_id" :options="corporateList" valueProp="mst_corporate_id"
                label="mst_corporate_name" track-by="mst_corporate_name" placeholder="-- Pilih Corporate --"
                :searchable="true" :can-clear="true" />
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Site</label>
              <Multiselect v-model="form.mst_site_id" :options="siteList" valueProp="mst_site_id" label="mst_site_name"
                track-by="mst_site_name" placeholder="-- Pilih Site --" :searchable="true" :can-clear="true" />
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Department</label>
              <Multiselect v-model="form.mst_division_id" :options="divisionList" valueProp="mst_division_id"
                label="mst_division_name" track-by="mst_division_name" placeholder="-- Pilih Department --"
                :searchable="true" :can-clear="true" />
            </div>
  
            <div class="col-md-4">
              <label class="form-label fw-semibold">Position</label>
              <Multiselect v-model="form.mst_position_id" :options="positionList" valueProp="mst_position_id"
                label="mst_position_name" track-by="mst_position_name" placeholder="-- Pilih Position --"
                :searchable="true" :can-clear="true" />
            </div>
  
          </div>
        </div>
  
        <!-- 3. Spesifikasi Hardware -->
        <div class="border rounded p-3">
          <p class="fw-semibold text-muted small text-uppercase mb-3">Spesifikasi Hardware</p>
          <div class="row g-3">
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Merk</label>
              <input type="text" class="form-control" v-model="form.asset_merk">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Type</label>
              <input type="text" class="form-control" v-model="form.asset_type">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Processor</label>
              <input type="text" class="form-control" v-model="form.asset_processor">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">RAM</label>
              <input type="text" class="form-control" v-model="form.asset_ram">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">HDD</label>
              <input type="text" class="form-control" v-model="form.asset_hdd">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">SSD</label>
              <input type="text" class="form-control" v-model="form.asset_ssd">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Operating System</label>
              <input type="text" class="form-control" v-model="form.asset_operating_system">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Office</label>
              <input type="text" class="form-control" v-model="form.asset_office">
            </div>
  
          </div>
        </div>
  
        <!-- 4. Lisensi -->
        <div class="border rounded p-3">
          <p class="fw-semibold text-muted small text-uppercase mb-3">Lisensi</p>
          <div class="row g-3">
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">COA OS</label>
              <select class="form-select" v-model="form.asset_coa_os">
                <option value="">-- Pilih --</option>
                <option v-for="item in coaList" :key="item.value" :value="item.value">
                  {{ item.description }}
                </option>
              </select>
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Product Key OS</label>
              <input type="text" class="form-control" v-model="form.asset_product_key_os">
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">COA Office</label>
              <select class="form-select" v-model="form.asset_coa_office">
                <option value="">-- Pilih --</option>
                <option v-for="item in coaList" :key="item.value" :value="item.value">
                  {{ item.description }}
                </option>
              </select>
            </div>
  
            <div class="col-md-3">
              <label class="form-label fw-semibold">Product Key Office</label>
              <input type="text" class="form-control" v-model="form.asset_product_key_office">
            </div>
  
            <!-- Gambar Lisensi / COA -->
            <div class="col-12">
              <label class="form-label fw-semibold">Gambar Lisensi</label>
              <small class="text-muted d-block mb-2">JPG / PNG.</small>
  
              <div class="d-flex flex-wrap gap-2 mb-2">
                <!-- Gambar tersimpan -->
                <div v-for="doc in existingDocuments.filter(d => d.is_image == 1 || d.document_type == 4)"
                  :key="'lic-ex-' + doc.asset_document_id"
                  class="d-flex align-items-center gap-2 border rounded px-2 py-1" style="max-width:260px">
                  <i class="bi bi-image text-secondary"></i>
                  <span class="small text-truncate flex-grow-1" :title="doc.file_name">
                    {{ doc.file_name || 'image' }}
                  </span>
                  <button type="button" class="btn btn-outline-primary btn-sm py-0 px-1" title="Lihat"
                    @click="downloadFile(doc.file_path)">
                    <i class="bi bi-eye"></i>
                  </button>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" title="Hapus"
                    @click="removeExistingDocument(existingDocuments.indexOf(doc))">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
  
                <!-- Gambar baru -->
                <div v-for="(f, idx) in newLicenseImages" :key="'lic-new-' + idx"
                  class="d-flex align-items-center gap-2 border rounded px-2 py-1 bg-light" style="max-width:260px">
                  <i class="bi bi-image text-secondary"></i>
                  <span class="small text-truncate flex-grow-1" :title="f.name">{{ f.name }}</span>
                  <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" title="Hapus"
                    @click="removeLicenseImage(idx)">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
  
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="$refs.licInput.click()">
                <i class="bi bi-image"></i> Upload Gambar
              </button>
              <input ref="licInput" type="file" accept="image/jpeg,image/png,image/webp" multiple class="d-none"
                @change="addLicenseImages" />
            </div>
  
          </div>
        </div>
  
        <!-- 5. Dokumen Pendukung -->
        <div class="border rounded p-3">
          <p class="fw-semibold text-muted small text-uppercase mb-3">Dokumen Pendukung</p>
  
          <small class="text-muted d-block mb-3">
            Upload PDF, max 10MB per file. Bisa lebih dari satu file.
          </small>
  
          <!-- File lama (kolom file_path, tanpa tipe) -->
          <div v-for="(key, idx) in form.existing_files" :key="'old-' + idx"
            class="d-flex align-items-center justify-content-between py-2 px-3 mb-2 border rounded-3"
            style="max-width:560px">
            <div class="d-flex align-items-center gap-2 text-truncate">
              <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
              <span class="text-truncate" style="font-size:0.875rem">{{ getFileName(key) }}</span>
            </div>
            <div class="d-flex align-items-center gap-2 flex-shrink-0">
              <button type="button" class="btn btn-outline-primary btn-sm" title="Lihat" @click="downloadFile(key)">
                <i class="bi bi-eye"></i>
              </button>
              <button type="button" class="btn btn-outline-danger btn-sm" title="Hapus" @click="removeExistingFile(idx)">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
  
          <!-- Dokumen tersimpan (bertipe, bukan gambar) -->
          <template v-for="(doc, idx) in existingDocuments" :key="'doc-ex-' + doc.asset_document_id">
            <div v-if="!(doc.is_image == 1 || doc.document_type == 4)"
              class="d-flex align-items-center justify-content-between py-2 px-3 mb-2 border rounded-3"
              style="max-width:560px">
              <div class="d-flex align-items-center gap-2 text-truncate">
                <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                <span class="text-truncate small">{{ doc.file_name || getFileName(doc.file_path) }}</span>
              </div>
              <div class="d-flex align-items-center gap-2 flex-shrink-0">
                <button type="button" class="btn btn-outline-primary btn-sm" title="Lihat"
                  @click="downloadFile(doc.file_path)">
                  <i class="bi bi-eye"></i>
                </button>
                <button type="button" class="btn btn-outline-danger btn-sm" title="Hapus"
                  @click="removeExistingDocument(idx)">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </template>
  
          <!-- Dokumen baru (multi) — tanpa tipe/keterangan -->
          <div v-for="(doc, idx) in newDocuments" :key="'doc-new-' + idx"
            class="d-flex align-items-center gap-2 px-3 py-2 mb-2 border rounded-3 bg-light" style="max-width:560px">
            <i class="bi bi-file-earmark-pdf-fill text-danger fs-4 flex-shrink-0"></i>
            <div class="flex-grow-1 text-truncate">
              <div class="small fw-semibold text-truncate">{{ doc.file.name }}</div>
              <small class="text-muted">{{ (doc.file.size / 1024).toFixed(0) }} KB</small>
            </div>
            <button type="button" class="btn btn-outline-danger btn-sm flex-shrink-0" title="Hapus"
              @click="removeNewDocument(idx)">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
  
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="$refs.docInput.click()">
            <i class="bi bi-plus-lg"></i> Tambah Dokumen PDF
          </button>
          <input ref="docInput" type="file" accept=".pdf,application/pdf" multiple class="d-none"
            @change="addNewDocument" />
  
          <!-- Bukti Penjualan / Pemusnahan (khusus Retired) -->
          <template v-if="isRetired">
            <hr class="my-4">
  
            <label class="form-label fw-semibold">Dokumen Bukti Penjualan / Pemusnahan</label>
  
            <!-- File lama (edit mode) -->
            <div v-if="mode === 'edit' && form.existing_retired_file"
              class="d-flex align-items-center justify-content-between py-2 px-3 mb-2 border rounded-3"
              style="max-width:560px">
              <div class="d-flex align-items-center gap-2 text-truncate">
                <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                <span class="text-truncate" style="font-size:0.875rem">
                  {{ getFileName(form.existing_retired_file) }}
                </span>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button type="button" class="btn btn-outline-primary btn-sm" title="Preview"
                  @click="downloadFile(form.existing_retired_file)">
                  <i class="bi bi-eye"></i>
                </button>
                <button type="button" class="btn btn-outline-danger btn-sm" title="Hapus"
                  @click="removeExistingRetiredFile">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
  
            <!-- File baru -->
            <div v-if="form.retired_file"
              class="d-flex align-items-center justify-content-between px-3 py-2 border rounded-3 bg-light mb-2"
              style="max-width:560px">
              <div class="d-flex align-items-center gap-2">
                <i class="bi bi-file-earmark-pdf-fill text-danger fs-4"></i>
                <div>
                  <div class="fw-semibold" style="font-size:0.875rem">{{ form.retired_file.name }}</div>
                  <small class="text-muted">{{ (form.retired_file.size / 1024).toFixed(0) }} KB</small>
                </div>
              </div>
              <button type="button" class="btn btn-outline-danger btn-sm" @click="removeNewRetiredFile">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
  
            <!-- Drop zone -->
            <div v-if="!form.existing_retired_file && !form.retired_file" class="upload-box upload-box-sm"
              :class="{ dragging: isDraggingRetired }" @dragover.prevent="isDraggingRetired = true"
              @dragleave.prevent="isDraggingRetired = false" @drop.prevent="handleRetiredDrop"
              @click="$refs.retiredFileInput.click()">
              <input ref="retiredFileInput" type="file" accept=".pdf" class="d-none" @change="handleRetiredFileUpload">
              <i class="bi bi-cloud-upload upload-icon upload-icon-sm"></i>
              <span class="upload-text">
                Drag &amp; drop file, atau <span class="text-primary" style="cursor:pointer">klik untuk browse</span>
                — PDF (max 10MB)
              </span>
            </div>
          </template>
        </div>
  
      </div>
  
      <!-- BUTTON -->
      <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
        <button class="btn btn-secondary" @click="goBack" :disabled="isLoading">
          Cancel
        </button>
        <button class="btn btn-primary" :disabled="isLoading" @click="saveData">
          <span v-if="isLoading" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="bi bi-floppy"></i>
          {{ submitLabel }}
        </button>
      </div>
    </template>
  
  </div>
</template>

<script>
import AssetFormViewJs from "./AssetFormView";
export default AssetFormViewJs;
</script>

<style scoped>
.uppercase-select :deep(.multiselect-search),
.uppercase-select :deep(.multiselect-single-label),
.uppercase-select :deep(.multiselect-option) {
  text-transform: uppercase;
}
</style>
